import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CondicoesMoradia } from 'src/app/core/condicoes-moradia';
import { CondicoesMoradiaService } from 'src/app/services/condicoes-moradia/condicoes-moradia.service';
import { Aluno } from '../../../../core/aluno';
import { Escola } from '../../../../core/escola';
import { EscolaService } from '../../../../services/escola/escola.service';

@Component({
  selector: 'escolar-aluno',
  templateUrl: './escolar-aluno.component.html',
  styleUrls: ['./escolar-aluno.component.css']
})
export class EscolarAlunoComponent implements OnInit, OnChanges {

  @Input() aluno: Aluno;

  tipoEscola: any;
  condicoesMoradia: CondicoesMoradia[];
  nomeRa: string;


  escolas: Escola[] = [];

  constructor(private condicaoMoradiaService: CondicoesMoradiaService,
    private escolaService: EscolaService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.aluno && changes.aluno.currentValue) {
      if (changes.aluno.currentValue.pessoaFisica) {
        const pessoaFisica = changes.aluno.currentValue.pessoaFisica;
        if (pessoaFisica.escola) {
          if (pessoaFisica.escola.regiaoAdministrativa) {
            this.nomeRa = pessoaFisica.escola.regiaoAdministrativa.nome;
          }
          this.tipoEscola = pessoaFisica.escola.tipo;
          this.carregarEscolas();
        }

        if (!pessoaFisica.serieEscolar || !pessoaFisica.serieEscolar.id) {
          this.aluno.pessoaFisica.serieEscolar = {
            id: null,
            descricao: null
          };
        }
      }
    }
  }


  ngOnInit() {
    this.aluno.pessoaFisica.condicoesMoradia = new CondicoesMoradia();

    this.condicaoMoradiaService.getAll().subscribe((condicoes: CondicoesMoradia[]) => {
      this.condicoesMoradia = condicoes;
    });
  }

  carregarEscolas() {
    if (this.tipoEscola) {
      this.escolaService.getAllEscolasByCombo(this.tipoEscola).subscribe((escolas: Escola[]) => {
        this.escolas = escolas;
      });
    }
  }

  preencherRa(event: Escola) {
    if(event && event.regiaoAdministrativa) {
      this.nomeRa = event.regiaoAdministrativa.nome;
    } else {
      this.nomeRa = null;
    }
  }

  onTipoEscolaChange(tipoEscola: any) {
    this.tipoEscola = tipoEscola?.flag;
    this.carregarEscolas();
  }

  onSerieEscolarChange(serieEscolar: any) {
    this.aluno.pessoaFisica.serieEscolar = serieEscolar;
  }

  onTurnoChange(turno: any) {
    this.aluno.pessoaFisica.turno = turno?.flag;
  }
}
